import { mediasoupClientConfig } from "../components/mediasoup/mediasoup";

export async function getMeetingMedia(
  constraints: MediaStreamConstraints = {},
): Promise<MediaStream> {
  return navigator.mediaDevices.getUserMedia({
    audio: constraints.audio ?? mediasoupClientConfig.audioConstraints,
    video: constraints.video ?? mediasoupClientConfig.videoConstraints,
  });
}

export function setTrackEnabled(
  stream: MediaStream | null,
  kind: "audio" | "video",
  enabled: boolean,
): void {
  stream
    ?.getTracks()
    .filter((track) => track.kind === kind)
    .forEach((track) => {
      track.enabled = enabled;
    });
}
